"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDisabled;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDisabled() {
  return [(0, _useWebChatAPIContext.default)().disabled];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VEaXNhYmxlZCIsInVzZVdlYkNoYXRBUElDb250ZXh0IiwiZGlzYWJsZWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VEaXNhYmxlZC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZURpc2FibGVkKCk6IFtib29sZWFuXSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5kaXNhYmxlZF07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLFdBQVQsR0FBa0M7RUFDL0MsT0FBTyxDQUFDLElBQUFDLDZCQUFBLElBQXVCQyxRQUF4QixDQUFQO0FBQ0QifQ==